// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"a4a334f7","113":"46898319","165":"02ee92e4","192":"fbef02fa","218":"6b60823d","280":"dbb6e667","453":"9f63d18e","550":"adca05b0","813":"539fbc6d","837":"d8b7d392","874":"73b7ac5a"}[chunkId] + ".chunk.js";
};